import { render } from "./AppScores.vue?vue&type=template&id=fcd99b40&lang=pug"
import script from "./AppScores.vue?vue&type=script&lang=js"
export * from "./AppScores.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__